export interface HomepageIntroduction {
    title: string
    subtitle: string
    introduction: string
    imageCaption: string
    quoteOriginal: string
    quoteTranslation: string
    quoteSource: string
}


function state() {
    const result: HomepageIntroduction = {
        title: "智能媒体与认知实验室",
        subtitle: "清华大学，软件学院",
        quoteOriginal: "“La science n’a pas pour objet les choses elles-mêmes, mais les relations entre les choses.”",
        quoteTranslation: "“科学研究的对象并不是事物本身，而是事物之间的关系。”",
        quoteSource: "亨利·庞加莱（Henri Poincaré）",
        introduction: "现实世界由大量复杂交互构成：从社会媒体、化学反应到生命与生态系统，许多关系并非只发生在两个对象之间，而是由多个实体共同形成。仅用孤立数据点或成对连接来建模，往往只能看见复杂系统的局部。超图为这种高阶关联提供了自然的表示与计算框架。\n智能媒体与认知实验室（iMoon Lab）聚焦人工智能、特别是超图计算领域展开研究，系统性提出超图计算理论方法，并应用于计算机视觉、智慧医疗、大模型等领域，从复杂关联中获得更可靠、更完整的智能认知能力。",
        imageCaption: "孤立数据点与成对关系只能呈现局部；通过超图融合可观测数据与隐式高阶关联，才能形成更完整的表示并服务下游任务。"
    }
    const result_en: HomepageIntroduction = {
        title: "Intelligent Media and Cognition Lab (iMoon Lab)",
        subtitle: "School of Software, Tsinghua University",
        quoteOriginal: "“La science n’a pas pour objet les choses elles-mêmes, mais les relations entre les choses.”",
        quoteTranslation: "“Science does not study things themselves, but only the relations between things.”",
        quoteSource: "Henri Poincaré",
        introduction: "The real world is shaped by complex interactions. From social media and chemical reactions to biological and ecological systems, many relationships are formed jointly by multiple entities rather than by pairs alone. Models based only on isolated data points or pairwise links often capture only part of the system. Hypergraphs provide a natural representation and computational framework for these higher-order correlations.\nThe Intelligent Media and Cognition Lab (iMoon Lab) focuses on artificial intelligence, especially hypergraph computation. We systematically develop theories and methods for hypergraph computation and apply them to computer vision, medical intelligence, foundation models, and related fields, aiming to obtain more reliable and complete machine cognition from complex relations.",
        imageCaption: "isolated observations and pairwise links reveal only fragments. Hypergraphs fuse observable data with implicit higher-order correlations to form a more complete representation for downstream tasks."
    }
    return { zh: result, en: result_en }
}

export default state()
